import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Tooltip,
  Link,
  Select,
  MenuItem,
} from "@material-ui/core";
import {
  IdProvider,
  AdminSourceResponse,
  RootStatus,
  SourceType,
} from "@authory-packages/core";
import FindInPageIcon from "@material-ui/icons/FindInPage";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import LinkIcon from "@material-ui/icons/Link";
import { IconStyles, TableWebsiteStyles } from "../../styles";
import { SourceStats } from "./SourceStats";
import React, { useEffect } from "react";
import { useLocation } from "@reach/router";
import { getHashAnchor, goToAnchor } from "../../utils/scrollToSource";
import { enumToOptions } from "../../lib/enumToOption";

type SourceMetaProps = {
  source: AdminSourceResponse;
  url: string;
  onTypeChange: (event: React.ChangeEvent<any>) => void;
  onTypeBlur: (event: React.ChangeEvent<any>) => void;
  typeVal: string;
};

// Generate status select options from enum
const typeOptions = enumToOptions(SourceType);

export const SourceMeta = ({
  source,
  url,
  typeVal,
  onTypeChange,
  onTypeBlur,
}: SourceMetaProps) => {
  const tableStyles = TableWebsiteStyles();
  const iconClasses = IconStyles();
  const location = useLocation();

  const hashAnchor = getHashAnchor(source);
  const isHighlighted = location.hash === hashAnchor;

  useEffect(() => {
    if (isHighlighted) {
      goToAnchor(source);
    }
  }, []);

  return (
    <div style={{ display: "flex" }}>
      <Table size="small" className={tableStyles.root}>
        <TableBody>
          <TableRow>
            <TableCell align="center">
              <div className={iconClasses.panel}>
                {source.googleSearchUrl && (
                  <Tooltip title="Open in Google (same query as the search engine import)">
                    {
                      <Link
                        className={iconClasses.root}
                        href={source.googleSearchUrl}
                        target="_blank"
                      >
                        <FindInPageIcon
                          className={iconClasses.root}
                          color="action"
                        />
                      </Link>
                    }
                  </Tooltip>
                )}
                {url && (
                  <Tooltip title="Open url">
                    {
                      <Link
                        className={iconClasses.root}
                        href={url || ""}
                        target="_blank"
                      >
                        <OpenInNewIcon
                          className={iconClasses.root}
                          color="action"
                        />
                      </Link>
                    }
                  </Tooltip>
                )}
              </div>
            </TableCell>
            <TableCell>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography
                  color={!isHighlighted ? "textSecondary" : "error"}
                  component="span"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {`${
                    source.rootId
                      ? `${IdProvider.toRootId(source.rootId)} | `
                      : ""
                  } ${source.id ? IdProvider.toWebsiteId(source.id) : ""}`}
                </Typography>
                <a
                  href={hashAnchor}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    marginLeft: "10px",
                    marginTop: "4px",
                  }}
                >
                  <LinkIcon />
                </a>
              </div>
            </TableCell>
            <TableCell>
              {source.stage === RootStatus.New ? (
                <Select
                  name="type"
                  value={typeVal}
                  onChange={onTypeChange}
                  onBlur={onTypeBlur}
                >
                  {typeOptions.map((st) => (
                    <MenuItem key={st.value} value={st.value}>
                      {st.label}
                    </MenuItem>
                  ))}
                </Select>
              ) : (
                <Typography color="textSecondary">{source.type}</Typography>
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <SourceStats source={source} />
    </div>
  );
};
